import React from "react";
import PropTypes from "prop-types";
import { Header, Form, Message } from "semantic-ui-react";

export const FileUploadSection = ({
  paymentImagePreview,
  paymentMessage,
  onImageUpload,
}) => {
  return (
    <div>
      <Header as="h4">Upload Payment Receipt</Header>
      <Form>
        <Form.Field>
          <input type="file" accept="image/*" onChange={onImageUpload} />
          <div className="file-upload-help">
            Accepted formats: JPG, PNG (Max 5MB)
          </div>
        </Form.Field>

        {paymentImagePreview && (
          <div className="receipt-preview">
            <Header as="h5">Receipt Preview</Header>
            <img src={paymentImagePreview} alt="Payment receipt preview" />
          </div>
        )}

        {paymentMessage && (
          <Message
            color={paymentMessage.includes("Error") ? "red" : "green"}
            content={paymentMessage}
            className="upload-message"
          />
        )}
      </Form>
    </div>
  );
};

FileUploadSection.propTypes = {
  paymentImagePreview: PropTypes.string,
  paymentMessage: PropTypes.string,
  onImageUpload: PropTypes.func.isRequired,
};
